import React from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { BatteryCharging, Wifi, Armchair } from "lucide-react";

export default function Fleet() {
  const fleet = [
    {
      image: "https://images.unsplash.com/photo-1632276536839-84cad7fd03b0",
      name: "Electric Shuttle",
      type: "40 Seater • EV",
      features: ["Zero Emissions", "Silent Cabin", "WiFi Enabled"]
    },
    {
      image: "https://images.unsplash.com/photo-1635612418051-4a8727412644",
      name: "Executive Coach",
      type: "20 Seater • Luxury",
      features: ["Reclining Seats", "USB Charging", "Reading Lights"]
    },
    {
      image: "https://images.unsplash.com/photo-1643686978040-beac9782e58b", // Using dashboard image as placeholder for tech-enabled cab
      name: "Smart Cab",
      type: "4 Seater • Sedan",
      features: ["GPS Tracking", "Panic Button", "AC Climate Control"]
    },
    {
      image: "https://images.unsplash.com/photo-1605410791216-3d9653a95667",
      name: "Corporate Van",
      type: "8-16 Seater • Shuttle",
      features: ["Spacious Interior", "WiFi Enabled", "Group Commute"]
    },
  ];

  return (
    <section id="fleet" className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Modern, Comfortable Fleet</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From electric buses to executive sedans, our fleet is designed for comfort, sustainability, and reliability.
          </p>
        </div>

        <Carousel className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {fleet.map((vehicle, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3 pl-6">
                <div className="p-1">
                  <Card className="overflow-hidden border-none shadow-lg group">
                    <div className="relative h-64 overflow-hidden">
                      <img 
                        src={vehicle.image} 
                        alt={vehicle.name} 
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-primary">
                        {vehicle.type}
                      </div>
                    </div>
                    <CardContent className="p-6">
                      <h3 className="text-xl font-bold text-primary mb-4">{vehicle.name}</h3>
                      <div className="space-y-3">
                        {vehicle.features.map((feature, i) => (
                          <div key={i} className="flex items-center gap-2 text-sm text-muted-foreground">
                            {i === 0 && <BatteryCharging className="h-4 w-4 text-green-500" />}
                            {i === 1 && <Armchair className="h-4 w-4 text-blue-500" />}
                            {i === 2 && <Wifi className="h-4 w-4 text-secondary" />}
                            {feature}
                          </div>
                        ))}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </div>
    </section>
  );
}
